export const USER_ROLE = {
  EMPLOYEE: "Employee",
  HR: "HR",
  TEACHER: "Teacher",
};
